import { cn } from "@/src/js/lib/utils";
import { useChart, type ChartConfig } from "../../ui/chart";
import { chartStyles } from "../chartStyles";

interface InsightLegendContentProps {
  payload?: Array<{
    value: string;
    color?: string;
    dataKey?: string;
    type?: string;
  }>;
  verticalAlign?: "top" | "bottom";
}

function getConfigLabel(config: ChartConfig, key: string): string | undefined {
  const entry = config[key];
  if (entry?.label && typeof entry.label === "string") {
    return entry.label;
  }
  return undefined;
}

export function InsightLegendContent({
  payload,
  verticalAlign = "bottom",
}: InsightLegendContentProps) {
  const { config } = useChart();

  if (!payload?.length) return null;

  return (
    <div className={cn(chartStyles.legendContainer, verticalAlign === "top" && "tw:pb-3 tw:pt-0")}>
      {payload
        .filter((item) => item.type !== "none")
        .map((item) => {
          const key = item.dataKey || "value";
          const label = getConfigLabel(config, key) ?? item.value;

          return (
            <div key={item.value} className={chartStyles.legendItem}>
              <div className={chartStyles.swatch} style={{ backgroundColor: item.color }} />
              <span>{label}</span>
            </div>
          );
        })}
    </div>
  );
}
